import BigModal from "../common/modals/BigModal";
import FloatingLabelInput from "../common/inputs/FloatingLabelInput";
import FloatingLabelInputGroup from "../common/inputs/FloatingLabelInputGroup";
import useFetchGraphQL from '../../hooks/useFetchGraphQL';
import { useState, useEffect } from "react";
import config from "../../config";

const VoucherOverviewModal = ({ t, voucherInfo, onClose }) => {
  const { fetchVoucherByPk } = useFetchGraphQL();
  const [isLoading, setIsLoading] = useState(false);
  const [voucher, setVoucher] = useState({Available: ""});

  useEffect(() => {
    if (!voucherInfo?.code) return;

    setIsLoading(true);
    fetchVoucherByPk(voucherInfo.code)
      .then((response) => {
        const voucherByPk = response.data?.data?.voucher_by_pk || null;
        setVoucher(voucherByPk);
      })
      .catch(() => {
        setVoucher(null);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [voucherInfo?.code]);
  
  const isFound = voucher !== null;
  const logo = <div className="big-modal-main"><img src={config.globalLogo} alt="Logo"></img></div>

  const foundBody = (isFound &&
    <div className="big-modal-main">
      <h2>{t("pages.voucher_overview.modal.title_found")}</h2>
      <div className="input-container">
        <FloatingLabelInputGroup 
          inputs={[
            { label: t("pages.voucher_overview.modal.created_date"), value: voucher?.CreatedDateTime ? new Date(voucher.CreatedDateTime).toLocaleString("fr-FR") : "", disabled: true },
            { label: t("pages.voucher_overview.modal.expiry_date"), value: voucher?.ExpiryDateTime ? new Date(voucher.ExpiryDateTime).toLocaleString("fr-FR") : "", disabled: true },
          ]}
        />
        <FloatingLabelInput label={t("pages.voucher_overview.modal.email")} value={voucher.Email} disabled />
        <FloatingLabelInput label={t("pages.voucher_overview.modal.voucher_id")} value={voucher.id} disabled />
        <FloatingLabelInputGroup 
          inputs={[
            { label: t("pages.voucher_overview.modal.bono_count"), value: voucher.BonoCount, disabled: true },
            { label: t("pages.voucher_overview.modal.available"), value: voucher.Available !== "" ? (voucher.Available ? t("pages.voucher_overview.modal.yes") : t("pages.voucher_overview.modal.no")) : "", disabled: true },
          ]}
        />
      </div>
    </div>
  );

  const button = (
    <>
      {!isLoading &&
        <button onClick={onClose} className="modal-button close-modal-button">{t("pages.voucher_overview.modal.close_button")}</button>
      }
      {isLoading && <div className="loading-spinner"><span>{t("pages.voucher_overview.modal.loading")}</span></div>}
    </>
  );

  const notFoundBody = (!isFound &&
    <div className="big-modal-main">
      <h2>{t("pages.voucher_overview.modal.title_not_found")}</h2>
      <div className="input-container">
        {t("pages.voucher_overview.modal.text_not_found")}
      </div>
    </div>
  );

  return (
    <BigModal 
      title={''}
      leftContent={isFound ? foundBody : notFoundBody}
      rightContent={logo}
      onClose= {onClose} 
      footerButton={button}
      onBack={onClose}
    />
  );
};

export default VoucherOverviewModal;